import { Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

const ToggleReservationButton = ({ handleClick }) => {
  return (
    <Button
      onClick={handleClick}
      sx={{
        width: "fit-content",
        backgroundColor: "#636AE8",
        color: "#FFFFFF",
        padding: "20px",
        borderRadius: "50%",
        position: "fixed",
        bottom: "20px",
        right: "20px",
      }}
      variant="contained"
    >
      <AddIcon />
    </Button>
  );
};

export default ToggleReservationButton;
